import request from '@/axios'

// 获取角色列表
export const getRoleList = (data: object) => {
  return request.post({ url: '/role/pageList', data })
}

// 获取所有产品线
export const getAllProductLine = (data: object) => {
  return request.post({ url: '/product/allProductLine', data })
}

// 获取所有部门
export const getAllDepartment = (data?: object) => {
  return request.post({ url: '/account/getAllDepartment', data })
}

// 获取角色详情
export const getRoleDetail = (data: object) => {
  return request.post({ url: '/role/roleDetail', data })
}

// 添加角色
export const addRole = (data: object) => {
  return request.post({ url: '/role/addRole', data })
}

// 编辑角色
export const editRole = (data: object) => {
  return request.post({ url: '/role/modifyRole', data })
}

// 删除角色
export const deleteRole = (data: object) => {
  return request.post({ url: '/role/deleteRole', data })
}

// 获取全量菜单树
export const getAllMenu = (data: object) => {
  return request.post({ url: '/role/allOprPermission', data })
}

// 获取全量
export const getAllMasterColumns = (data: object) => {
  return request.post({ url: '/masterData/getAllColumns', data })
}

// 校验权限表达式
export const checkRoleExpr = (data: object) => {
  return request.post({ url: '/role/checkExpr', data })
}

// 获取菜单权限
export const getRolePermission = (data: object = {}) => {
  return request.post({
    url: '/role/permission',
    data: {
      ...data,
      terminalType: 'pc'
    }
  })
}
// 获取模型权限
export const getRoleModelPermission = (data: object = {}) => {
  return request.post({ url: '/role/modelOprPermission', data })
}
// 菜单权限前置校验
export const permissionCheck = (data: object) => {
  return request.post({ url: '/role/permissionCheck', data })
}

//查询账号权限详情
export const getAccountPermission = (data: object) => {
  return request.post({ url: '/role/accountPermission', data })
}

//查询部门权限详情
export const getDepartmentPermission = (data: object) => {
  return request.post({ url: '/role/departmentPermission', data })
}

//查询部门的角色列表
export const getDepartmentRole = (data: object) => {
  return request.post({ url: '/role/departmentRole', data })
}

// 获取多角色权限
export const getMultiRolePermission = (data: object) => {
  return request.post({ url: '/role/multiRolePermission', data })
}

// 获取所有产品线
export const getProductType = (data: object) => {
  return request.post({ url: '/report/common/product-form', data })
}

// 查看所有权限 /bi-manage/account/menuDataPermission
export const getAllPermission = (data: object) => {
  return request.post({ url: '/account/menuDataPermission', data })
}
